var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var initializeModules = require( "./lib/init-modules.js" );

$(function() {
	initializeModules();
});
